import { Component, OnInit, ViewEncapsulation, OnDestroy, ViewChild } from '@angular/core';
import * as XlsxPopulate from 'xlsx-populate/browser/xlsx-populate';
import * as moment from 'moment';
import { Loan, SavingParameters, ClaimLevel, PeriodTypeEnum, Parameter, LoanListItem } from '@akiba/models_bimbo';
import { Subscription } from 'rxjs';
import { LogicService } from '../../../services/logic.service';
import { DataSourceService } from '../../../services/data-source.service';
import { PendingLoanRequestLogicService } from '../../../services/pending-loan-request-logic.service';
import { AuthenticationService } from '../../../services/authentication.service';
import { MatSelectChange, MatSnackBar } from '@angular/material';
import { UiService } from '../../../services/ui.service';

@Component({
  selector: 'app-pending-request',
  templateUrl: './pending-request.component.html',
  styleUrls: ['./pending-request.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class PendingRequestComponent implements OnInit, OnDestroy {


  excelFile: File;
  currentWorkBookSheet = 0;
  excelFields = ['ID Ciclo', 'ID Empleado', 'Nombre Empleado', 'Fecha De Solicitud', 'Importe', 'Cuotas', 'Forma De Pago', 'Ahorrador', 'Tipo De Trabajo'];


  displayedColumns: string[] = ['index', 'employeeNumber', 'username', 'email', 'createdAt', 'details'];
  displayedDeniedColumns: string[] = ['employeeNumber', 'username', 'email', 'createdAt', 'details'];
  pendingList: Array<LoanListItem> = new Array<LoanListItem>();
  pendingListSubscription: Subscription;
  selectedList: Array<LoanListItem> = new Array<LoanListItem>();
  periodToEdit: Parameter;
  deniedList: Array<LoanListItem> = new Array<LoanListItem>();
  deniedListSubscription: Subscription;
  totalResults: number;
  /** search */
  stateSearchBox: { query: string; refine: Function } = {
    query: '',
    refine() { }
  };
  /////////////////////////////////
  //////////////////////////////////

  period: Parameter;
  periods: Array<Parameter> = Array<Parameter>();
  appLogicChangesSubscription: Subscription = null;

  loading = false;
  currentCount = 0;

  //////////////////////////////////
  //////////////////////////////////

  loanTypes: Array<any> = new Array<any>();
  typeOptions = { permanent: { title: 'Mostrar préstamos de caja permanente', type: 'permanent', }, retirement: { title: 'Mostrar préstamos de caja retiro', type: 'retirement' } };
  selectedType: any = null;
  constructor(public logicService: LogicService, private pendingLoans: PendingLoanRequestLogicService, private authService: AuthenticationService, private UI: UiService, public snackBar: MatSnackBar) {

  }

  ngOnInit() {
    
    this.cancelSubscriptions();

  }

  
  ngAfterContentInit(){
    this.doSubscriptions();
  }

  

  async selectedPeriodChange(event: MatSelectChange) {

    if (!event.value) {
      this.selectedType = null;
      this.selectedList = new Array<LoanListItem>();
    } else {
      this.selectedType = event.value;
      this.selectedList = this.pendingLoans.pendingList.filter(aLoan => {

        if (aLoan.type === this.selectedType.type) {
          this.period = this.periods.find(p => p.parametersID === aLoan.parametersID);

          if (this.period) {
            return true;
          }

        }

        return false;

      });
      this.totalResults = this.selectedList.length;

    }

    let listPending = this.selectedList.slice(0, 20);


  }

  get isUserAdmin(): boolean {
    const result = this.authService.appLevel.currentClaim === ClaimLevel.administrator || this.authService.appLevel.currentClaim === ClaimLevel.akiba;
    return result;
  }

  async doSubscriptions() {

    this.appLogicChangesSubscription = this.logicService.dataManager.parameterDataLoader.changes.subscribe(c => {

      if (!c.response) {
        return;
      }

      if (this.logicService.dataManager.parameterDataLoader.parameters && this.logicService.dataManager.parameterDataLoader.parameters.length) {

        this.periods = this.logicService.dataManager.parameterDataLoader.parameters.filter(element => {
          if (element.type === PeriodTypeEnum.permanentSaving) {
            return true;
          } else if (element.type === PeriodTypeEnum.retirementSaving) {
            return true;
          }
          return false;
        });

        this.loadData(false);

      }

    });

    this.pendingListSubscription = this.pendingLoans.pendingListCountSubject.subscribe(async count => {

      if (count > 0) {

        if (this.currentCount > 0 && this.currentCount < count) {
          let snackBarRef = this.snackBar.open('Nuevos préstamos han sido solicitados.', 'Cargar', {
            duration: 5000,
            panelClass: ['green-snackbar']
          });

          snackBarRef.onAction().subscribe(() => {
            this.loadData(true);
          });

        }

        this.currentCount = count;


      }

      this.logicService.dataManager.parameterDataLoader.load();

    });

    this.deniedListSubscription = this.pendingLoans.deniedListCountSubject.subscribe(async count => {
      this.deniedList = this.pendingLoans.deniedList;
    });

  }

  async loadData(refresh: boolean = false) {

     

    if (this.pendingLoans.pendingList.length === 0 || refresh === true) {

      this.pendingLoans.pendingList = new Array<LoanListItem>();

      const snackBar = this.snackBar.open('Cargando...', null, {
        panelClass: ['green-snackbar']
      });

      snackBar.dismiss();

    }

    this.pendingList = this.pendingLoans.pendingList;
    const mySet = new Set();
    this.pendingList.forEach(element => {
      mySet.add(element.type);
    });

    this.loanTypes = new Array<any>();
    mySet.forEach((e: string) => this.loanTypes.push(this.typeOptions[e]));

    if (this.selectedType) {

      this.selectedList = this.pendingLoans.pendingList.filter(aLoan => {

        if (aLoan.type === this.selectedType.type) {
          this.period = this.periods.find(p => p.parametersID === aLoan.parametersID);

          if (this.period) {
            return true;
          }

        }

        return false;

      });

    }

  }

  cancelSubscriptions() {

    if (this.appLogicChangesSubscription && !this.appLogicChangesSubscription.closed) {
      this.appLogicChangesSubscription.unsubscribe();
    }

    if (this.pendingListSubscription && !this.pendingListSubscription.closed) {
      this.pendingListSubscription.unsubscribe();
    }

    if (this.deniedListSubscription && !this.deniedListSubscription.closed) {
      this.deniedListSubscription.unsubscribe();
    }

    // this.pendingLoans.pendingList.splice(0, this.pendingLoans.pendingList.length);

  }

  ngOnDestroy(): void {
    this.cancelSubscriptions();
  }

}
